/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Key_Task_Stage_ChangeInputs */

const cs_audit_key_task_stage_change = /** @type {(inputs: Audit_Key_Task_Stage_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změna fáze úkolu`)
};

const en_audit_key_task_stage_change = /** @type {(inputs: Audit_Key_Task_Stage_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task stage changed`)
};

/**
* | output |
* | --- |
* | "Task stage changed" |
*
* @param {Audit_Key_Task_Stage_ChangeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_key_task_stage_change = /** @type {((inputs?: Audit_Key_Task_Stage_ChangeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Key_Task_Stage_ChangeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_key_task_stage_change(inputs)
	return cs_audit_key_task_stage_change(inputs)
});